var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgPin(props, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M5.002 3c0-.553.447-1 1-1h7.997c.553 0 1 .447 1 1 0 .553-.447 1-1 1h-.922l.357 4.631a5.25 5.25 0 012.483 2.96l.031.093c.103.307.05.641-.137.9-.188.26-.49.416-.813.416H5.002a1 1 0 01-.95-1.316l.032-.093a5.25 5.25 0 012.483-2.96L6.923 4h-.921c-.553 0-1-.447-1-1zm3.999 11H11v3a.999.999 0 11-2 0v-3z",
    fill: "#0D2976"
  })));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgPin);
export default ForwardRef;